import { ReactComponent as Checkmark } from 'assets/icons/icon-checkmark.svg';

export default Checkmark;
